/**
 * NSM site Header — logo from assets/branding/logo.png, nav from site config.
 * Uses existing eventflow classes for styling.
 */
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/branding/logo.png";
import { TicketLink } from "../elements/TicketLink";
import { site } from "../../config/site";

const DESKTOP_BP = 992;

export default function Header() {
  const [stuck, setStuck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window === "undefined" ? true : window.innerWidth >= DESKTOP_BP
  );

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 10);
    const onResize = () => setIsDesktop(window.innerWidth >= DESKTOP_BP);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });
    onScroll();
    onResize();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("nsm-mobile-open", isOpen);
    return () => document.body.classList.remove("nsm-mobile-open");
  }, [isOpen]);

  return (
    <>
      <header className={`site-header site-header--nsm ${stuck ? "is-sticky" : ""}`}>
        <div className="main-menu">
          <div className="container">
            <div
              className="main-menu__wrapper"
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}
            >
              <div className="main-menu__left" style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <div className="main-menu__logo">
                  <Link to="/" aria-label="NEXT SUPER MODEL">
                    <img src={logo} alt="NEXT SUPER MODEL" />
                  </Link>
                </div>
              </div>

              <div className="main-menu__right" style={{ display: "flex", alignItems: "center", gap: 24 }}>
                {isDesktop && (
                  <>
                    <nav className="main-menu__nav" aria-label="Main">
                      <ul
                        className="main-menu__list"
                        style={{ display: "flex", alignItems: "center", gap: 28, margin: 0, padding: 0, listStyle: "none" }}
                      >
                        <li>
                          <NavLink to="/" end className="nsm-nav-link" style={{ textDecoration: "none" }}>Home</NavLink>
                        </li>
                        <li>
                          <NavLink to="/gallery" className="nsm-nav-link" style={{ textDecoration: "none" }}>Gallery</NavLink>
                        </li>
                        <li>
                          <NavLink to="/contact" end className="nsm-nav-link" style={{ textDecoration: "none" }}>Contact</NavLink>
                        </li>
                      </ul>
                    </nav>
                    <TicketLink
                      className="nsm-link-ticket"
                      style={{
                        color: "#ffc107",
                        textDecoration: "none",
                        textTransform: "uppercase",
                        fontWeight: 800,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {site.ctaNav}
                    </TicketLink>
                  </>
                )}

                {!isDesktop && (
                  <button
                    type="button"
                    className={`mobile-nav__toggler${isOpen ? " is-active" : ""}`}
                    aria-label="Menu"
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen((v) => !v)}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {!isDesktop && (
        <div
          aria-hidden={!isOpen}
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.6)",
            backdropFilter: "blur(2px)",
            visibility: isOpen ? "visible" : "hidden",
            opacity: isOpen ? 1 : 0,
            transition: "opacity .2s ease, visibility .2s ease",
            zIndex: 1000,
          }}
        >
          <nav
            className="nsm-mobile-nav"
            role="menu"
            aria-label="Mobile"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              height: "100%",
              width: "80%",
              maxWidth: 320,
              background: "#0f0f11",
              padding: "20px 16px",
              boxShadow: "-4px 0 24px rgba(0,0,0,.35)",
              transform: isOpen ? "translateX(0)" : "translateX(100%)",
              transition: "transform .2s ease",
            }}
          >
            <button
              aria-label="Close"
              onClick={() => setIsOpen(false)}
              style={{ position: "absolute", top: 10, right: 12, width: 36, height: 36, border: 0, background: "transparent", color: "#fff", fontSize: 26, cursor: "pointer" }}
            >
              ×
            </button>
            <ul style={{ listStyle: "none", padding: 0, margin: "48px 0 0", display: "grid", gap: 18 }}>
              <li>
                <NavLink to="/" end className="nsm-nav-link" onClick={() => setIsOpen(false)} style={{ color: "#fff", textDecoration: "none", fontWeight: 700, fontSize: 18 }}>Home</NavLink>
              </li>
              <li>
                <NavLink to="/gallery" className="nsm-nav-link" onClick={() => setIsOpen(false)} style={{ color: "#fff", textDecoration: "none", fontWeight: 700, fontSize: 18 }}>Gallery</NavLink>
              </li>
              <li>
                <NavLink to="/contact" end className="nsm-nav-link" onClick={() => setIsOpen(false)} style={{ color: "#fff", textDecoration: "none", fontWeight: 700, fontSize: 18 }}>Contact</NavLink>
              </li>
              <li>
                <TicketLink
                  onClick={() => setIsOpen(false)}
                  style={{ color: "#ffc107", textDecoration: "none", fontWeight: 800, fontSize: 18, textTransform: "uppercase" }}
                >
                  {site.ctaNav}
                </TicketLink>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
}
